module.exports = __webpack_public_path__ + "static/media/gravitron.99530091.png";